/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      component — thin session-backed shell for an operator/contact row
 *   extends:   Component (@glimmer/component)
 *   template:  contact-item.hbs
 *   args:      @c, @operatoreFirst, @setContact
 *   uses:      session service
 *   siblings:  contact-list.hbs, contact-button.js, back-link.js, product-item.js, invoice-item.js
 *   tests:     list-components-test.js, callback-args-test.js
 *
 * Renders an operator/contact row (name, thumbnail with fallback avatar,
 * first-available-date), selecting the contact via @setContact on click.
 */
import Component from '@glimmer/component';
import { service } from '@ember/service';

export default class ContactItemComponent extends Component {
  @service session;
}
